import React, { useState } from "react";
import swal from "sweetalert";
import Container from "../../../components/Container/Container";
import Table from "../../../components/Table/Table";
import { API, ROUTER } from "../../../constants/env";

const ListServices = () => {
  const [fields, __] = useState([
    { title: "Nom du service", field: "name" },
    { title: "Prix (TND)", field: "price" },
  ]);
  const [data, setData] = React.useState([]);

  const fetchData = (currentPage, count, search, setTotalPage, setTotal) => {
    fetch(
      API.services.serviceList +
        `?page=${currentPage}&count=${count}&searchQuery=${search}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      }
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          return swal("Error", response.message, "error");
        }

        setData(response.data);
        setTotalPage(response.totalPage);
        setTotal(response.total);
      })
      .catch((e) => {
        return swal("Error", e.message, "error");
      });
  };

  return (
    <Container
      name="Services"
      actionRoute={ROUTER.SERVICES.CREATE}
      actionName="Ajouter service"
    >
      <Table
        pageName="serv"
        name="Services"
        fields={fields}
        data={data}
        editRoute={(id) => ROUTER.SERVICES.EDIT(id)}
        deleteApiRoute={API.services.remove}
        deleteMultiple={API.services.deleteMultiple}
        fetchData={fetchData}
        showSearch={true}
        stopCheckbox={true}
      />
    </Container>
  );
};

export default ListServices;
